import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {GlobalStyles} from "@mui/material";
const globalStyle = {
   ".rsw-editor": {
      borderRadius: 0
   },
   ".rsw-toolbar": {
      backgroundColor: '#f0f0f0',
      padding: '0px 12px 0 12px'
   },
   ".rsw-ce": {
      padding: "12px"
   }
}

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
   <React.StrictMode>
      <GlobalStyles styles={globalStyle}/>
      <App/>
   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
